if (!customElements.get("infinite-page")) {
  class infinitePageComponent extends HTMLElement {
    constructor() {
      super();
      this.section = this.dataset.section;
      this.nextPageUrl = this.dataset.nextPageUrl;
      this.containerId = this.dataset.containerId;
      this.loading = false;
      // When element is in viewport, load more content
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadMore();
          }
        });
      });
      observer.observe(this);
    }

    loadMore() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      // Get the next page number
      if (this.nextPageUrl) {
        fetch(`${this.nextPageUrl}&sections=${this.section}`, {
          method: "GET",
          credentials: "same-origin",
        })
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              console.error(error);
            }

            return response.json();
          })
          .then((res) => {
            if (res[this.section]) {
              const resultsMarkup = new DOMParser().parseFromString(res[this.section], "text/html").querySelector(`#${this.containerId}`).innerHTML;
              document.querySelector(`#${this.containerId}`).insertAdjacentHTML("beforeend", resultsMarkup);
              // notify listeners (filtres custom, etc.) avant de retirer l'élément
              document.dispatchEvent(new CustomEvent("infinite-page:loaded", {
                detail: { containerId: this.containerId, section: this.section },
              }));
              // delete this element
              this.remove();
            }
          })
          .catch((error) => { console.error("infinite-page fetch error:", error); });
      }
    }
  }

  customElements.define("infinite-page", infinitePageComponent);
}